var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIconGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.346,
    height: 16.722,
    viewBox: "0 0 18.346 16.722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-svgrepo-com",
    transform: "translate(-27.9 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(27.9 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M144.125,5a.727.727,0,0,0-.727.727V15.739l-2.484-2.484a.726.726,0,1,0-1.027,1.027L143.61,18a.724.724,0,0,0,1.023,0l3.722-3.722a.726.726,0,1,0-1.027-1.027l-2.484,2.484V5.723A.713.713,0,0,0,144.125,5Z",
    transform: "translate(-134.952 -5)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M46.246,360.939v-4.213a.727.727,0,0,0-1.453,0v3.49H29.349v-3.49a.725.725,0,1,0-1.449,0v4.213a.723.723,0,0,0,.727.723H45.519A.723.723,0,0,0,46.246,360.939Z",
    transform: "translate(-27.9 -344.94)",
    fill: "#898989"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconGray);
export default __webpack_public_path__ + "static/media/download_icon_gray.4a351e35061bccd460eb06af3b76aaef.svg";
export { ForwardRef as ReactComponent };